import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertMmt',
  standalone: true // Use standalone: false if your app uses older NgModule architecture
})
export class ConvertMmtPipe implements PipeTransform {

  transform(value: string | undefined | null): string {
    if (!value) return '';

    try {
      // 1. Split date components out of your format: '24/09/2026 09:06:45'
      const [datePart, timePart] = value.split(' ');
      const [day, month, year] = datePart.split('/').map(Number);
      const [hours, minutes, seconds] = timePart.split(':').map(Number);

      // 2. Build a valid Javascript Date object (Months are 0-indexed in JS)
      const dateObj = new Date(year, month - 1, day, hours, minutes, seconds);

      // 3. Add the 6 hours and 30 minutes for Myanmar Time adjustment
      dateObj.setHours(dateObj.getHours() + 6);
      dateObj.setMinutes(dateObj.getMinutes() + 30);

      // 4. Extract newly shifted fragments
      const d = String(dateObj.getDate()).padStart(2, '0');
      const m = String(dateObj.getMonth() + 1).padStart(2, '0');
      const y = dateObj.getFullYear();

      const hr = String(dateObj.getHours()).padStart(2, '0');
      const min = String(dateObj.getMinutes()).padStart(2, '0');
      const sec = String(dateObj.getSeconds()).padStart(2, '0');

      // Returns the updated format precisely: '24/09/2026 15:36:45'
      return `${d}/${m}/${y} ${hr}:${min}:${sec}`;
    } catch (error) {
      console.error('Error transforming custom date string:', error);
      return value; // Return fallback unchanged string if string parse faults occur
    }
  }
}
